import styled from 'styled-components';
import { BADI_COLORS } from '@badi/badi-components';

export const IconWrapper = styled.div`
  path {
    fill: ${BADI_COLORS.NEUTRAL.NEUTRAL_00};
  }
`;
